import { render, staticRenderFns } from "./modalLinkTerm.vue?vue&type=template&id=9ac0f39c&"
import script from "./modalLinkTerm.vue?vue&type=script&lang=js&"
export * from "./modalLinkTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports